module.exports = __webpack_public_path__ + "media/images/icon_list/time-3d1661b927fb4e09944f1daee24ed6a0.svg";